/**
 * Logger 유틸리티
 *
 * 기본 레벨: WARN — console에는 경고와 에러만 표시.
 * 개발 시 상세 로그가 필요하면 브라우저 콘솔에서:
 *   localStorage.setItem('LOG_LEVEL', 'DEBUG')
 * 후 새로고침. 'INFO', 'WARN', 'ERROR', 'NONE' 도 가능.
 */

const LOG_LEVELS = {
  DEBUG: 0,
  INFO: 1,
  WARN: 2,
  ERROR: 3,
  NONE: 4,
};

// 🔥 [2026-06-27 보안] 운영 빌드에서는 DEBUG/INFO 를 절대 출력하지 않는다(개인정보 콘솔 노출 방지).
//   localStorage LOG_LEVEL 로도 운영에서는 WARN 미만으로 내릴 수 없음.
const IS_PROD = (() => { try { return Boolean(import.meta.env && import.meta.env.PROD); } catch (_) { return false; } })();
const MIN_LEVEL = IS_PROD ? LOG_LEVELS.WARN : LOG_LEVELS.DEBUG;

function clampLevel(lvl) { return lvl < MIN_LEVEL ? MIN_LEVEL : lvl; }

function getInitialLevel() {
  try {
    const stored = localStorage.getItem('LOG_LEVEL');
    if (stored && LOG_LEVELS[stored] !== undefined) {
      return clampLevel(LOG_LEVELS[stored]);
    }
  } catch (_) {
    // SSR or localStorage 접근 불가
  }
  return LOG_LEVELS.WARN;
}

class Logger {
  constructor() {
    this.currentLevel = getInitialLevel();
  }

  setLevel(level) {
    if (LOG_LEVELS[level] !== undefined) {
      this.currentLevel = clampLevel(LOG_LEVELS[level]);
    }
  }

  debug(...args) {
    if (this.currentLevel <= LOG_LEVELS.DEBUG) {
      console.log(...args);
    }
  }

  info(...args) {
    if (this.currentLevel <= LOG_LEVELS.INFO) {
      console.log(...args);
    }
  }

  warn(...args) {
    if (this.currentLevel <= LOG_LEVELS.WARN) {
      console.warn(...args);
    }
  }

  error(...args) {
    if (this.currentLevel <= LOG_LEVELS.ERROR) {
      console.error(...args);
    }
  }
}

const logger = new Logger();

export default logger;
export { LOG_LEVELS };
